import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { FormSwitch } from "@redotech/redo-web/switch";
import { input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const showSuppliesStorefrontInput = input<boolean>();
export const showSuppliesStorefrontDefault = false;

// These map to settings.supplies (not settings.outboundLabels); the outbound
// label form reads/writes them separately in its value builder and save.
export const allowInventoryTriggeredReorderingInput = input<boolean>();
export const allowInventoryTriggeredReorderingDefault = false;

export const allowScheduledReorderingInput = input<boolean>();
export const allowScheduledReorderingDefault = false;

export const SuppliesSettingsCard = memo(function SuppliesSettingsCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  return (
    <Card title="Supplies Settings" w="full">
      <Flex dir="column" gap="md">
        <FormSwitch
          input={input.inputs.showSuppliesStorefront}
          label="Show Supplies Storefront"
        />
        <FormSwitch
          input={input.inputs.allowInventoryTriggeredReordering}
          label="Allow inventory-triggered reordering"
        />
        <FormSwitch
          disabled
          disabledTooltip="Scheduled reordering isn't available yet"
          input={input.inputs.allowScheduledReordering}
          label="Allow scheduled reordering"
        />
      </Flex>
    </Card>
  );
});
